<template>
  <el-container>
    <el-main>
      <el-dialog
          :title="$t('butler.apartmentShare')"
          :modal-append-to-body="false"
          :lock-scroll="false"
          :visible.sync="groupVisible"
          width="600px"
        >
           <el-table
            ref="groupTable"
            :data="groupData"
            highlight-current-row
            tooltip-effect="dark"
            @selection-change="groupDataChange"
            style="width: 100%; margin-top: -10px"
            max-height="250"
          >
          <el-table-column type="selection"></el-table-column>
          <el-table-column
            type="index"
            :label="$t('butler.number')"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="groupName"
            :label="$t('groupList.groupName')"
            width="180"
            align="center"
          ></el-table-column>
          <!-- <el-table-column
            prop="roomNames"
            label="房间"
            align="center"

          ></el-table-column> -->
          <el-table-column
            prop="createTime"
            :label="$t('groupList.createTime')"
            align="center"
            width="160"
            :formatter="this.$util.datetimeFormat"
          >
          </el-table-column>
        </el-table>
         <div style="margin-top: 10px">
            <el-button type="primary" @click="confirmChooseGroup">{{
              $t("butler.confirm")
            }}</el-button>
            <el-button type="primary" @click="groupVisible = false">{{
              $t("butler.cancel")
            }}</el-button>
          </div>
      </el-dialog>
      <el-dialog
          :title="$t('butler.apartmentShareBtn')"
          :modal-append-to-body="false"
          :lock-scroll="false"
          :visible.sync="staffManageVisible"
          width="665px"
        >
          <el-form-item
            label-width="120px"
            :label="$t('butler.apartmentName')"
            style="margin-top: -20px"
          >
            <el-input
              v-model="selectForm.apartmentName"
              :placeholder="$t('butler.apartmentName')"
            ></el-input>
          </el-form-item>
          <el-form-item style="margin-top: -20px">
            <el-button type="primary" @click="onApartmentSelect">{{
              $t("butler.qurey")
            }}</el-button>
            <!-- <el-button type="primary" @click="onCreate">增加网关</el-button> -->
          </el-form-item>
          <el-table
            ref="multipleTable"
            :data="staffApartmentList"
            highlight-current-row
            tooltip-effect="dark"
            @selection-change="handleCurrentChangeDetail"
            style="width: 100%; margin-top: -10px"
            max-height="250"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column
              property="apartmentName"
              :label="$t('butler.apartmentName')"
            ></el-table-column>
            <el-table-column
              property="city"
              :label="$t('butler.city')"
            ></el-table-column>
            <el-table-column
              property="apartmentAddress"
              :label="$t('butler.address')"
            ></el-table-column>
            <el-table-column
              property="staffNames"
              :label="$t('butler.authorizedButler')"
            ></el-table-column>
          </el-table>

          <!-- <div style="margin-top: 10px;">
        <Pagings
          :total="butlerApartmentTotal"
          :offset="BAPageData.butlerApartmentOffset"
          :pageSize="BAPageData.butlerApartmentPageNumber"
          @handleSizeChangeSub="butlerApartmentHandleSizeChange"
          @handleCurrentChangeSub="butlerApartmentHandleCurrentChange"
        ></Pagings>
      </div> -->
          <div style="margin-top: 10px">
            <el-button type="primary" @click="confirmChooseTenant">{{
              $t("butler.confirm")
            }}</el-button>
            <el-button type="primary" @click="staffManageVisible = false">{{
              $t("butler.cancel")
            }}</el-button>
          </div>
      </el-dialog>
        
        <!-- 编辑角色 -->
        <el-dialog
          :title="$t('butler.editButlerRole')"
          :modal-append-to-body="false"
          :lock-scroll="false"
          :visible.sync="editStaffRoleVisible"
          width="400px"
        >
         <el-form :inline="true" :model="editStaffRoleForm" class="demo-form-inline">  
          <el-form-item :label="$t('butler.butlerRole')" label-width="140px">
            <el-select
              v-model="editStaffRoleForm.roleId"
              style="width: 180px"
              :placeholder="$t('butler.butlerRole')"
            >
              <el-option
                v-for="item in roleList"
                :key="item.roleId"
                :label="item.roleName"
                :value="item.roleId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('butler.butlerId')" label-width="140px">
            <el-input
              v-model="editStaffRoleForm.staffUserAccount"
              :placeholder="$t('butler.butlerId')"
              style="width: 180px"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('butler.butlerName')" label-width="140px">
            <el-input
              v-model="editStaffRoleForm.staffName"
              :placeholder="$t('butler.butlerName')"
              style="width: 180px"
            ></el-input>
          </el-form-item>
            <el-form-item :label="$t('butler.staffPassword')" label-width="140px">
            <el-input
              type="text"
              v-model="editStaffRoleForm.staffPassword"
              maxlength="25"
              show-word-limit
              :placeholder="$t('butler.inputStaffPassword')"
              style="width: 180px"
            ></el-input>
          </el-form-item>
          <el-row
            style="display: flex; justify-content: center; align-items: center"
          >
            <el-button type="primary" @click="onEditRoleSubmit">{{
              $t("butler.confirm")
            }}</el-button>
            <el-button type="primary" @click="editStaffRoleVisible = false">{{
              $t("butler.cancel")
            }}</el-button>
          </el-row>
         </el-form> 
        </el-dialog>

        <!-- 添加员工 -->
        <el-dialog
          :title="$t('butler.addButler')"
          :modal-append-to-body="false"
          :lock-scroll="false"
          :visible.sync="addStaffVisible"
          width="500px"
        >
         <el-form :inline="true" :model="addStaffForm" class="demo-form-inline">  
          <el-form-item :label="$t('butler.accountType')" label-width="140px">
            <el-radio-group v-model="addStaffForm.accountType">
              <!-- <el-radio :label="0">{{ $t("butler.butlerId") }}</el-radio> -->
              <el-radio :label="1">{{ $t("butler.mobile") }}</el-radio>
              <el-radio :label="2">{{ $t("butler.email") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-show="addStaffForm.accountType == 0"
            :label="$t('butler.butlerId')"
            label-width="140px"
          >
            <el-input
              type="text"
              v-model.number="addStaffForm.userAccount"
              maxlength="18"
              show-word-limit
              :placeholder="$t('butler.butler-input')"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-show="addStaffForm.accountType == 1"
            :label="$t('butler.mobile')"
            label-width="140px"
          >
            <el-input
              type="text"
              v-model.number="addStaffForm.userAccount"
              :placeholder="$t('butler.mobile-input')"
              maxlength="12"
              show-word-limit
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-show="addStaffForm.accountType == 2"
            :label="$t('butler.email')"
            label-width="140px"
          >
            <el-input
              v-model="addStaffForm.userAccount"
              :placeholder="$t('butler.email-input')"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('butler.butlerRole')" label-width="140px">
            <el-select
              v-model="addStaffForm.roleId"
              style="width: 200px"
              filterable
              :placeholder="$t('butler.role-input')"
            >
              <el-option
                v-for="item in roleList"
                :key="item.roleId"
                :label="item.roleName"
                :value="item.roleId"
              ></el-option>
            </el-select>
          </el-form-item>
           <el-form-item :label="$t('butler.staffPassword')" label-width="140px">
            <el-input
              type="password"
              v-model="addStaffForm.staffPassword"
              maxlength="25"
              show-word-limit
              :placeholder="$t('butler.inputStaffPassword')"
              style="width:200px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('butler.butlerName')" label-width="140px">
            <el-input
              type="text"
              v-model="addStaffForm.staffName"
              maxlength="18"
              show-word-limit
              :placeholder="$t('butler.bulter-input')"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-row
            style="display: flex; justify-content: center; align-items: center"
          >
            <el-button type="primary" @click="onSubmit">{{
              $t("butler.confirm")
            }}</el-button>
            <el-button type="primary" @click="addStaffVisible = false">{{
              $t("butler.cancel")
            }}</el-button>
          </el-row>
         </el-form> 
        </el-dialog>
      <el-form :inline="true" :model="formStaffList" class="demo-form-inline">  
        <el-form-item :label="$t('butler.butlerName')">
          <el-input
            v-model="formStaffList.staffName"
            :placeholder="$t('butler.bulter-input')"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSelect">{{
            $t("butler.qurey")
          }}</el-button>
          <!-- <el-button type="primary" @click="onCreate">增加网关</el-button> -->
        </el-form-item>
         <el-form-item style="float:right">
          <el-button
          icon="el-icon-plus"
          style=""
          @click="openAddButler"
          >{{ $t("butler.addButler") }}</el-button>
         </el-form-item> 
      </el-form>
      <template>
        <el-table
          :data="tableData"
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
          empty-text="No Data"
          border
        >
          <el-table-column
            type="index"
            :label="$t('butler.number')"
            width="70"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="staffUserAccount"
            :label="$t('butler.staffAccount')"
            align="center"
            width="110"
            :show-overflow-tooltip='true'
          ></el-table-column>
          <el-table-column
            prop="staffName"
            :label="$t('butler.butlerName')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="roleName"
            :label="$t('butler.butlerRole')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="groupNameList"
            :label="$t('groupList.group')"
            align="center"
            width="150"
            :show-overflow-tooltip='true'
          ></el-table-column>
          
          <el-table-column
            prop="apartmentNameList"
            :label="$t('butler.authApartment')"
            width="150"
            :show-overflow-tooltip='true'
            align="center"
          >
            <template slot-scope="scope">
              {{apartmentListShow(scope.row.apartmentNameList) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="staffUserMobile"
            :label="$t('butler.mobile')"
            align="center"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="staffUserEmail"
            :label="$t('butler.email')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop=""
            :label="$t('butler.operate')"
            align="center"
            width="180"
          >
            <template slot-scope="scope">
              <el-button
                style='margin-top:5px'
                size="mini"
                @click="groupAllot(scope.$index, scope.row)"
                >{{$t('butler.groupAllocation')}}</el-button
              >
             
              <!-- <br> -->
              <el-button
                style='margin-top:5px;'
                size="mini"
                @click="staffApartmentManage(scope.$index, scope.row)"
                >{{$t("butler.apartmentShareBtn")}}</el-button
              >
              
              <el-button
                style='margin-top:5px'
                size="mini"
                @click="editStaffRole(scope.$index, scope.row)"
                >{{ $t("role.edit") }}</el-button
              >

              <el-button
                style='margin-top:5px'
                type="danger"
                size="mini"
                :title="$t('butler.delete')"
                @click="onDelete(scope.$index, scope.row)"
              >{{$t('butler.delete')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-main>
    <el-footer>
      <div>
        <Pagings
          :total="total"
          :offset="pageData.offset"
          :pageSize="pageData.pageNumber"
          @handleSizeChangeSub="handleSizeChange"
          @handleCurrentChangeSub="handleCurrentChange"
        ></Pagings>
      </div>
    </el-footer>
  </el-container>
</template>
<script>

import Pagings from "../common/Pagings.vue";
export default {
  name: "butlerList", //这个LoginName最好和引入的vue的LoginName相同
  data() {
    return {
      multipleSelectionAll: [],
      staffManageVisible: false,
      staffApartmentList: [],
      // butlerApartmentTotal: 1,
      currentStaffData: null,
      currentStaffApartmetnRow: null,
      selectForm: { apartmentName: "" },
      BAPageData: {
        staffApartmentOffset: 1,
        staffApartmentPageNumber: 100,
      },
      editStaffRoleVisible: false,
      editStaffRoleForm: {
        staffId: "",
        staffUserAccount: "",
        roleId: "",
        staffName: "",
        staffPassword:"",
      },
      addStaffVisible: false,
      roleList: [],
      addStaffForm: {
        accountType: 0,
        userAccount: "",
        countryId: 86,
        roleId: "",
        staffName: "",
        staffPassword: "",
      },
      pageData: {
        offset: 1,
        pageNumber: 10,
      },
      total: 1, //总条数
      tableData: [],
      formStaffList: {
        staffName: "",
      },
      groupVisible:false,
      groupData:[],
      groupSelectionAll:[]
    };
  },
  components: {
    Pagings,
  },
  created() {
    this.power();
    this.staffApartmentPower();
    this.getRoleList();
    // this.getGroupData();
  },
  methods: {
    //确定分组
    confirmChooseGroup(){
        var groupIds=[];
          for(var str in this.groupSelectionAll){
            groupIds.push(this.groupSelectionAll[str].groupId);
          }
        var formData = new FormData();
        formData.append("groupIdList",JSON.stringify(groupIds));
        formData.append("staffId",this.currentStaffData.staffId);
        this.$server
        .exam("/customer/staff/updateStaffGroupAuth", formData)
        .then((data) => {
          if (data.code == 200) {
              this.groupVisible=false;
              this.$message({
                message: data.message,
                type: "success",
              });
              this.power();//刷新分组列表
          } else {
              this.$message({
                  message: data.message,
                  type: "warning",
              });
          }
        });
    },
    //分组列表选择事件
    groupDataChange(selection){
      if (selection.length > 0) {
       this.groupSelectionAll=selection;
      }else{
       this.groupSelectionAll=[];
      }
    },
    //打开分组选择列表
    groupAllot(index,row){
       this.currentStaffData = row;
       this.groupVisible=true;
       this.getGroupData();//重新加载对应的人员分组
    },
    //管家查询
    onSelect() {
      this.power();
    },
    //公寓查询
    onApartmentSelect() {
      this.staffApartmentPower();
    },
    
    // 确认选择公寓
    confirmChooseTenant() {
      // alert(window.JSON.stringify(this.currentButlerApartmetnRow));
      // if (this.currentButlerApartmetnRow==""|| this.currentButlerApartmetnRow == null) {
      //   this.$message({
      //     message:  this.$t("butler.authorizedApartment-select"),
      //     type: "warning"
      //   });
      //   return false;
      // }
      var apartmentIdList = [];
      this.currentStaffApartmetnRow.filter(function (item) {
        apartmentIdList.push(item.apartmentId);
      });
      var formData = new FormData();
      formData.append(
        "apartmentIdList",
        window.JSON.stringify(apartmentIdList)
      );
      formData.append("staffId", this.currentStaffData.staffId);
      this.$server
        .exam("/customer/staff/updateStaffApartmentAuth", formData)
        .then((data) => {
          this.staffManageVisible = false;
          this.currentStaffData = null;
          if (data.code == 200) {
            this.$message({
              message: data.message,
              type: "success",
            });
            this.power();
            this.staffApartmentPower();
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
      // this.butlerManageVisible = false;
    },
    //选择公寓row
    handleCurrentChangeDetail(val) {
      if (val.length > 0) {
        this.currentStaffApartmetnRow = val;
        //  this.multipleSelectionAll.push(obj);
        // if(this.multipleSelectionAll.length==0||this.multipleSelectionAll==""){
        //     var obj={};
        //     obj.page=this.BAPageData.butlerApartmentOffset;
        //     obj.data=val;
        //     this.multipleSelectionAll.push(obj);
        // }else{
        //     this.checkSelectionAll(val);
        // }
      } else {
        this.currentStaffApartmetnRow = [];
      }
    },
    //打开授权公寓
    staffApartmentManage(index, row) {
      this.currentStaffData = row;
      this.staffManageVisible = true;
      this.selectForm.apartmentName = "";
      this.staffApartmentPower(); //重新加载列表
    },
    onDelete(index, row) {
      this.$confirm(
        this.$t("butler.deleteButler-confirm1") +
          row.staffName +
          this.$t("butler.deleteButler-confirm2"),
        this.$t("butler.hint"),
        {
          confirmButtonText: this.$t("butler.confirm"),
          cancelButtonText: this.$t("butler.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          var formData = new FormData();
          formData.append("staffId", row.staffId);
          this.$server
            .exam("/customer/staff/deleteStaff", formData)
            .then((data) => {
              if (data.code == 200) {
                this.$message({
                  message: data.message,
                  type: "success",
                });
                this.power();
              } else {
                this.$message({
                  message: data.message,
                  type: "warning",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("butler.cancelDelete"),
          });
        });
    },
    onEditRoleSubmit() {
      var formData = new FormData();
      formData.append("staffId", this.editStaffRoleForm.staffId);
      formData.append("roleId", this.editStaffRoleForm.roleId);
      formData.append("staffName", this.editStaffRoleForm.staffName);
      formData.append("staffPassword", this.editStaffRoleForm.staffPassword);
      this.$server
        .exam("/customer/staff/editStaff", formData)
        .then((data) => {
          this.editStaffRoleVisible = false;
          if (data.code == 200) {
            this.$message({
              message: data.message,
              type: "success",
            });
            this.power();
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
    },
    editStaffRole(index, row) {
      this.editStaffRoleVisible = true;
      this.editStaffRoleForm.roleId = row.roleId;
      this.editStaffRoleForm.staffName = row.staffName;
      this.editStaffRoleForm.staffUserAccount = row.staffUserAccount;
      this.editStaffRoleForm.staffId = row.staffId;
      this.editStaffRoleForm.staffPassword = row.staffPassword;
    },
    openAddButler() {
      this.addStaffVisible = true;
      this.addStaffForm.staffName = "";
      this.addStaffForm.roleId = "";
      this.addStaffForm.userAccount = "";
      this.addStaffForm.accountType = 1;
    },

    onSubmit() {
      var staffName = this.addStaffForm.staffName;
      var roleId = this.addStaffForm.roleId;
      var userAccount = this.addStaffForm.userAccount;
      var accountType = this.addStaffForm.accountType;
      var staffPassword=this.addStaffForm.staffPassword;
      var formData = new FormData();
      switch (accountType) {
        case 0:
          if (userAccount == "" || userAccount == null) {
            this.$message({
              message: this.$t("butler.butler-input"),
              type: "warning",
            });
            return false;
          }
          break;
        case 1:
          formData.append("countryId", 86);
          if (userAccount == "" || userAccount == null) {
            this.$message({
              message: this.$t("butler.mobile-input"),
              type: "warning",
            });
            return false;
          }
          var boolean = new RegExp("^[1-9][0-9]*$").test(userAccount);
          if (!boolean) {
            this.$message({
              message: this.$t("butler.mobile-input"),
              type: "warning",
            });
            return false;
          }
          break;
        case 2:
          if (userAccount == "" || userAccount == null) {
            this.$message({
              message: this.$t("butler.email-input"),
              type: "warning",
            });
            return false;
          }
          var mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
          if (!mailReg.test(userAccount)) {
            this.$message({
              message: this.$t("butler.email-input"),
              type: "warning",
            });
            return false;
          }
          break;
      }
      if (roleId == "" || roleId == null) {
        this.$message({
          message: this.$t("butler.role-input"),
          type: "warning",
        });
        return false;
      }
      if (staffName == "" || staffName == null) {
        this.$message({
          message: this.$t("butler.bulter-input"),
          type: "warning",
        });
        return false;
      }
      if (staffPassword == "" || staffPassword == null) {
        this.$message({
          message:this.$t('butler.inputStaffPassword'),
          type: "warning",
        });
        return false;
      }
      
      formData.append("accountType", accountType);
      formData.append("userAccount", userAccount);
      formData.append("staffName", staffName);
      formData.append("staffPassword", staffPassword);
      formData.append("roleId", roleId);
      this.$server.exam("/customer/staff/addStaff", formData).then((data) => {
        if (data.code == 200) {
          this.addStaffVisible = false;
          this.power();
        } else {
          this.$message({
            message: data.message,
            type: "warning",
          });
        }
      });
    },

    getRoleList() {
      var formData = new FormData();
      formData.append("pageNo", 1);
      formData.append("pageSize", 10);
      this.$server
        .exam("/customer/userRole/listRole", formData)
        .then((data) => {
          if (data.code == 200) {
            this.roleList = data.data.records;
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
    },

    //分解管家管理公寓
    apartmentListShow(data) {
      // var rtn = "";
      // if (data != "" && data != null&&data!="[]") {
      //   alert(data);
      //   for (var str in data) {
      //     rtn += data[str] + ",";
      //   }
      //   rtn = rtn.substring(0, rtn.length - 1);
      // }
      return data;
    },

    // checkSelectionAll(val) {
    //   var selectData = this.multipleSelectionAll;
    //   var isExit = false;
    //   for (var str in selectData) {
    //     //判断当前页选择是否在总列表是否存在
    //     if (selectData[str].page == this.BAPageData.staffApartmentOffset) {
    //       selectData[str].data = val;
    //       isExit = true;
    //     }
    //   }
    //   if (isExit) {
    //     this.multipleSelectionAll = selectData;
    //   } else {
    //     var obj = {};
    //     obj.page = this.BAPageData.staffApartmentOffset;
    //     obj.data = val;
    //     this.multipleSelectionAll.push(obj);
    //   }
    // },

     getGroupData() {
      var formData = new FormData();
      this.$server
        .exam("/customer/apartment/listGroup", formData)
        .then((data) => {
          if (data.code == 200) {
            this.groupData = data.data;
            // this.oAssEquipmentDto.offset = 1;
            // this.oAssEquipmentDto.pageNumber = data.data.pages;
            this.$nextTick(() => {
              this.groupData.forEach((row) => {
                if (
                  row.groupId != null &&
                  row.groupId != "" &&
                  this.currentStaffData != null &&
                  this.currentStaffData != ""
                ) {
                  if (this.currentStaffData.groupIdList.indexOf(row.groupId)>= 0) {
                    this.$refs.groupTable.toggleRowSelection(row);
                  }
                }
              });
            });
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
    },

    power() {
      var formData = new FormData();
      formData.append("pageNo", this.pageData.offset);
      formData.append("pageSize", this.pageData.pageNumber);
      // if (
      //   this.formStaffList.staffName != "" &&
      //   this.formStaffList.staffName != null
      // ) {
      //   formData.append("staffName", this.formButlerList.staffName);
      // }
      this.$server
        .exam("/customer/staff/listStaff", formData)
        .then((data) => {
          if (data.code == 200) {
            this.tableData = data.data.records;
            this.total = data.data.total;
            // this.oAssEquipmentDto.offset = 1;
            // this.oAssEquipmentDto.pageNumber = data.data.pages;
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
    },

    staffApartmentPower() {
      var formData = new FormData();
      formData.append("pageNo", this.BAPageData.staffApartmentOffset);
      formData.append("pageSize", this.BAPageData.staffApartmentPageNumber);
      if (
        this.selectForm.apartmentName != "" &&
        this.selectForm.apartmentName != null
      ) {
        formData.append("apartmentName", this.selectForm.apartmentName);
      }
      this.$server
        .exam("/customer/staff/listApartmentWithStaff", formData)
        .then((data) => {
          if (data.code == 200) {
            this.staffApartmentList = data.data.records;
            this.butlerApartmentTotal = data.data.total;
            // this.setPageSelect();
            // this.oAssEquipmentDto.offset = 1;
            // this.oAssEquipmentDto.pageNumber = data.data.pages;
            this.$nextTick(() => {
              this.staffApartmentList.forEach((row) => {
                if (
                  row.staffIds != null &&
                  row.staffIds != "" &&
                  this.currentStaffData != null &&
                  this.currentStaffData != ""
                ) {
                  if (
                    row.staffIds.indexOf(this.currentStaffData.staffId) >= 0
                  ) {
                    this.$refs.multipleTable.toggleRowSelection(row);
                  }
                }
              });
            });
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
    },
    setPageSelect() {
      var selectData = this.multipleSelectionAll;
      for (var str in selectData) {
        //判断当前页选择是否在总列表是否存在
        if (selectData[str].page == this.BAPageData.staffApartmentOffset) {
          var pageData = selectData[str].data;
          this.$nextTick(() => {
            pageData.forEach((row) => {
              // alert(window.JSON.stringify(row));
              this.$refs.multipleTable.toggleRowSelection(row, true);
              return true;
            });
          });
        }
      }
    },
    handleSizeChange(val) {
      this.pageData.pageNumber = val;
      this.power();
    },
    handleCurrentChange(val) {
      this.pageData.offset = val;
      this.power();
    },
    butlerApartmentHandleSizeChange(val) {
      this.BAPageData.staffApartmentPageNumber = val;
      this.staffApartmentPower();
    },
    butlerApartmentHandleCurrentChange(val) {
      this.BAPageData.staffApartmentOffset = val;
      this.staffApartmentPower();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/butler/butlerList.vue